import React from "react";
import "./MaintenanceScreen.css";

const MaintenanceScreen = ({ title, message, isAdmin = false, showPageInfo = false, pageKey = null }) => {
  return (
    <div className="maintenance-screen">
      <div className="maintenance-container">
        <div className="maintenance-icon">
          <svg
            width="120"
            height="120"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M12 2L13.09 8.26L18 7L16.74 12.74L22 14L15.74 15.09L17 20L11.26 18.91L10 24L8.74 18.91L3 20L4.26 14.74L-1 13L5.26 11.91L4 7L9.74 8.09L11 2H12Z"
              fill="#FFA500"
            />
            <path
              d="M12 8V16M8 12H16"
              stroke="white"
              strokeWidth="2"
              strokeLinecap="round"
            />
          </svg>
        </div>
        
        <h1 className="maintenance-title">{title}</h1>
        <p className="maintenance-message">{message}</p>
        
        {showPageInfo && pageKey && (
          <div className="page-maintenance-info">
            <p><strong>Affected Page:</strong> {pageKey}</p>
            <p>Other admin pages may still be available. Try accessing them from the sidebar.</p>
          </div>
        )}
        
        <div className="maintenance-info">
          <p>
            {isAdmin ? (
              <>
                If you need urgent assistance, please contact the system administrator.
              </>
            ) : showPageInfo ? (
              <>
                This specific page is temporarily unavailable. Please try other admin functions.
              </>
            ) : (
              <>
                Thank you for your patience. We'll be back online shortly.
              </>
            )}
          </p>
        </div>
        
        <div className="maintenance-footer">
          <button 
            className="refresh-button" 
            onClick={() => showPageInfo ? window.history.back() : window.location.reload()}
          >
            {showPageInfo ? 'Go Back' : 'Check Again'}
          </button>
        </div>
      </div>
    </div>
  );
};

export default MaintenanceScreen;
